@if (!isOnlytext) {
  <img
    src="/assets/img/help_outline_24px.svg"
    alt="help icon"
    width="18"
    height="18"
    style="margin-bottom: 2px; cursor: pointer"
    matTooltipClass="help-icon-tooltip"
    [matTooltip]="tooltipText"
    matTooltipPosition="above"
    (mouseenter)="onTooltipHover()"
    />
}

@if (isOnlytext) {
  <div [matTooltip]="tooltipText"  matTooltipPosition="above">
    <span [matTooltip]="tooltipText"  matTooltipPosition="above"></span>
  </div>
}